const t = {
  name: "PlusMedium",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 13V18H13V13H18V11H13V6H11V11H6V13H11Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as PlusMedium
};
